import { render, staticRenderFns } from "./AltaDeChips.vue?vue&type=template&id=aeedd418&scoped=true"
import script from "./AltaDeChips.vue?vue&type=script&lang=js"
export * from "./AltaDeChips.vue?vue&type=script&lang=js"
import style0 from "./AltaDeChips.vue?vue&type=style&index=0&id=aeedd418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeedd418",
  null
  
)

export default component.exports